var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-schedule"},[_c('div',{staticClass:"title f-bold",domProps:{"innerHTML":_vm._s("일정 선택이 완료되었어요")}}),_c('div',{staticClass:"body",domProps:{"innerHTML":_vm._s(_vm.body)}})])}
var staticRenderFns = []

export { render, staticRenderFns }